"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
/* istanbul ignore file */

const defaultTranslations = exports.defaultTranslations = {
  bpCount: '{0} BP',
  bvCount: '{0} BV',
  cataloguePrice: 'Catalogue price',
  qty: 'Qty',
  quantity: 'Quantity',
  regularPrice: 'Regular price',
  unitPrice: 'Unit price',
  whatsInside: 'What`s inside'
};
//# sourceMappingURL=defaultTranslations.js.map